export const STUDY_LEVEL_LIST_REQUEST = "STUDY_LEVEL_LIST_REQUEST"
export const STUDY_LEVEL_LIST_SUCCESS = "STUDY_LEVEL_LIST_SUCCESS"
export const STUDY_LEVEL_LIST_FAIL = "STUDY_LEVEL_LIST_FAIL"

export const STUDY_LEVEL_CREATE_REQUEST = "STUDY_LEVEL_CREATE_REQUEST"
export const STUDY_LEVEL_CREATE_SUCCESS = "STUDY_LEVEL_CREATE_SUCCESS"
export const STUDY_LEVEL_CREATE_FAIL = "STUDY_LEVEL_CREATE_FAIL"

